import * as con from './constants';
import { DocsListQuery } from '../../openapi/operations/docsList';
import { UsersListQuery } from '../../openapi/operations/usersList';

import type { PublishsetsListQuery } from '../../openapi/operations/publishsetsList';
import type { OrdersListQuery } from '../../openapi/operations/ordersList';
import type { EpsiOrdersListQuery } from '../../openapi/operations/epsiOrdersList';
import type { SubjektyListQuery } from '../../openapi/operations/subjektyList';
import type { GeodesistsListQuery } from '../../openapi/operations/geodesistsList';
import type { OrganizationsListQuery } from '../../openapi/operations/organizationsList';
import type { R7UrceniEditoraZpsListQuery } from '../../openapi/operations/r7UrceniEditoraZpsList';
import type { PriceListItemsListQuery } from '../../openapi/operations/priceListItemsList';
import type { ServiceOrdersListQuery } from '../../openapi/operations/serviceOrdersList';

export const setDocListFilter = (payload: DocsListQuery) => ({
  type: con.DOC_LIST_FILTER_SET,
  payload,
});

export const setCheckListFilter = (payload: DocsListQuery) => ({
  type: con.CHECK_LIST_FILTER_SET,
  payload,
});

export const setUserListFilter = (payload: UsersListQuery) => ({
  type: con.USER_LIST_FILTER_SET,
  payload,
});

export const setOrderListFilter = (payload: OrdersListQuery) => ({
  type: con.ORDER_LIST_FILTER_SET,
  payload,
});

export const setEpsiOrderListFilter = (payload: EpsiOrdersListQuery) => ({
  type: con.EPSI_ORDER_LIST_FILTER_SET,
  payload,
});

export const setPublishsetListFilter = (payload: PublishsetsListQuery) => ({
  type: con.PUBLISHSET_LIST_FILTER_SET,
  payload,
});

export const setSubjectListFilter = (payload: SubjektyListQuery) => ({
  type: con.SUBJECT_LIST_FILTER_SET,
  payload,
});

export const setGeodesistsListFilter = (payload: GeodesistsListQuery) => ({
  type: con.GEODESISTS_LIST_FILTER_SET,
  payload,
});

export const setOrganizationsListFilter = (payload: OrganizationsListQuery) => ({
  type: con.ORGANIZATION_LIST_FILTER_SET,
  payload,
});

export const setSvuListFilter = (payload: R7UrceniEditoraZpsListQuery) => ({
  type: con.SVU_LIST_FILTER_SET,
  payload,
});

export const setPriceListItemListFilter = (payload: PriceListItemsListQuery) => ({
  type: con.PRICE_LIST_ITEM_LIST_FILTER_SET,
  payload,
});

export const setServiceOrderListFilter = (payload: ServiceOrdersListQuery) => ({
  type: con.SERVICE_ORDER_LIST_FILTER_SET,
  payload,
});
